import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import classNames from "classnames";
import TableChartIcon from "@mui/icons-material/TableChart";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import Stack from "@mui/material/Stack";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
  TextareaAutosize,
} from "@mui/material";

//import {  } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
//import CurrencyFormat from 'react-currency-format';
import CurrencyInput from "react-currency-input-field";
import LoadingBox from "components/LoadingBox";
import MessageBox from "components/MessageBox";

import Notification from "components/Notification";
import styles from "assets/jss/vivoleo-react-kit/views/GenerateReportScreenStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TimeFilter from "components/TimeFilter";
import ReportItem from "components/ReportItem";
import { addReportItemAction } from "actions/FinanceReportActions";
import { convertStringToDate } from "utils.js";

const useStyles = makeStyles(styles);

export default function GenerateReportScreen(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const redirect = "/generatereport";
  const defaultYear = new Date().getFullYear();
  const [updateBtnShow, setUpdateBtnShow] = useState(true);
  const [listItemShow, setListItemShow] = useState(true);
  //const defaultFrom = new Date(defaultYear, 0, 1);
  const defaultFrom = "01/01/" + defaultYear;
  const defaultTo = "12/01/" + defaultYear;
  const [itemname, setItemname] = useState("Report Item");
  const [selectedFromDate, setSelectedFromDate] = useState(defaultFrom);
  const [selectedToDate, setSelectedToDate] = useState(defaultTo);
  const [selectedCategories, setSelectedCategories] = useState(["all"]);
  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  const addReportItem = useSelector((state) => state.addReportItem);
  const { generatedrptitem, loading, error } = addReportItem; //use previous records

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  const dispatch = useDispatch();

  const ItemReprotingCategory = (inputitem, inputCat) => {
    setSelectedCategories(inputCat);
    setItemname(inputitem);
    console.log("selectedCategories: " + selectedCategories);
    console.log("Itemname:" + itemname);
    document.getElementById("itemname").value = inputitem + "- " + inputCat;
    //setAddedCatIDs(addedCatIDs);
    if (
      inputitem !== null &&
      inputCat !== null &&
      inputitem !== "" &&
      inputCat !== ""
    ) {
      setUpdateBtnShow(false);
    }
  };

  const ItemReprotingPeriod = (inputFrom, inputTo) => {
    setSelectedFromDate(inputFrom);
    setSelectedToDate(inputTo);
    document.getElementById("selectedDate").value = inputFrom + "~" + inputTo;
  };
  const GenerateReport = () => {
    console.log(
      "Generating report...inputFrom~inputTo: " +
        selectedFromDate +
        "~" +
        selectedToDate
    );

    //e.preventDefault();
    //   if (password !== confirmPassword) {
    //     alert('Password and confirm password are not match');
    //   } else {
    const newfromdate = convertStringToDate(selectedFromDate);
    const newtodate = convertStringToDate(selectedToDate);
    console.log("newfromdate ~ newtodate: " + newfromdate + "~" + newtodate);
    dispatch(
      addReportItemAction({
        itemname,
        fromdate: newfromdate,
        todate: newtodate,
        user: userInfo._id,
        selectedcategories: selectedCategories,
        otherinfo: "no",
      })
    );
  };

  useEffect(() => {
    if (generatedrptitem) {
      setListItemShow(false);
      setNotify({
        isOpen: true,
        message: "Records Submitted Successfully",
        type: "success",
      });
      navigate(redirect, { replace: true });
    } else {
      console.log("error" + error);
      setNotify({
        isOpen: true,
        message: error,
        type: "failure",
      });
    }
  }, [props.history, redirect, generatedrptitem]);
  console.log("generatedrptitem: " + JSON.stringify(generatedrptitem));
  return (
    <div>
      <div className={classes.space30}> </div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes.textCenter}>
            <center>
              <h1> {[t("wordslib.generate"), t("wordslib.report")]}</h1>
            </center>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={
              <KeyboardBackspaceOutlinedIcon
                className={classes.vivoblueColor}
              />
            }
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={<TableChartIcon className={classes.vivoblueColor} />}
            onClick={() => navigate("/listreportitems")}
          >
            All Report Items
          </Button>
          <GridItem xs={12} sm={12} md={12}>
            <div className={classes.space30}> </div>
          </GridItem>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <TimeFilter ItemReprotingPeriod={ItemReprotingPeriod} />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <ReportItem ItemReprotingCategory={ItemReprotingCategory} />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <h3>Report</h3>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <InputLabel
            htmlFor="ReportPeriod"
            className={classNames(classes.subTitle)}
          >
            Reporting Period:
          </InputLabel>
          <TextareaAutosize
            maxRows={4}
            id="selectedDate"
            aria-label="maximum height"
            placeholder="Maximum 4 rows"
            defaultValue={selectedFromDate + "~" + selectedToDate}
            style={{ width: "100%", border: "none" }}
          />
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <InputLabel
            htmlFor="ReportItem"
            className={classNames(classes.subTitle)}
          >
            Report Item-Categories
          </InputLabel>
          <TextareaAutosize
            id="itemname"
            maxRows={4}
            aria-label="maximum height"
            defaultValue={itemname + " - " + selectedCategories}
            style={{ width: "100%", border: "none" }}
          />
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Button
            disabled={updateBtnShow}
            onClick={() => {
              GenerateReport();
            }}
            variant="outlined"
            size="small"
          >
            Generate Report Item
          </Button>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          {loading && <LoadingBox></LoadingBox>}
          {error && <MessageBox variant="danger">{error}</MessageBox>}
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          {/* generatedrptitem:{generatedrptitem} */}
          <Button
            variant="outlined"
            className="medium"
            disabled={listItemShow}
            onClick={() => navigate(`/rptitem/${itemname}`)}
          >
            {itemname}
          </Button>
        </GridItem>
        <Notification notify={notify} setNotify={setNotify}></Notification>
      </GridContainer>
    </div>
  );
}
